$(document).on('turbolinks:load', function() {
  $('select').on('change', function() {
    $(this).addClass('selected');
  })

  var pendingVpnCheckForm = null;
  var vpnModalReturnFocus = null;

  function openVpnModal() {
    vpnModalReturnFocus = document.activeElement;
    $('.vpn-ip-modal')
      .addClass('vpn-ip-modal--active')
      .attr('aria-hidden', 'false')
      .find('.vpn-ip-modal__dialog')
      .focus();
  }

  function closeVpnModal(restoreFocus) {
    var returnFocus = vpnModalReturnFocus;

    $('.vpn-ip-modal').removeClass('vpn-ip-modal--active').attr('aria-hidden', 'true');
    pendingVpnCheckForm = null;
    vpnModalReturnFocus = null;

    if (restoreFocus !== false && returnFocus && document.documentElement.contains(returnFocus)) {
      returnFocus.focus();
    }
  }

  $('.infection-check__content__form form[data-vpn-ip-detected="true"]').off('submit.vpnWarning').on('submit.vpnWarning', function(event) {
    if ($(this).data('vpnConfirmed')) {
      return true;
    }

    event.preventDefault();
    pendingVpnCheckForm = this;
    openVpnModal();
    return false;
  });

  $('.vpn-ip-modal__close, .vpn-ip-modal__backdrop').off('click.vpnWarning').on('click.vpnWarning', function(event, restoreFocus) {
    closeVpnModal(restoreFocus);
  });

  $('.vpn-ip-modal').off('keydown.vpnWarning').on('keydown.vpnWarning', function(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeVpnModal();
      return;
    }

    if (event.key !== 'Tab') {
      return;
    }

    var $focusableElements = $(this)
      .find('a[href], button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])')
      .filter(':visible');

    if ($focusableElements.length === 0) {
      event.preventDefault();
      return;
    }

    var firstFocusableElement = $focusableElements.first().get(0);
    var lastFocusableElement = $focusableElements.last().get(0);
    var modalDialog = $(this).find('.vpn-ip-modal__dialog').get(0);

    if (document.activeElement === modalDialog) {
      event.preventDefault();
      (event.shiftKey ? lastFocusableElement : firstFocusableElement).focus();
      return;
    }

    if (event.shiftKey && document.activeElement === firstFocusableElement) {
      event.preventDefault();
      lastFocusableElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastFocusableElement) {
      event.preventDefault();
      firstFocusableElement.focus();
    }
  });

  $('.vpn-ip-modal__continue').off('click.vpnWarning').on('click.vpnWarning', function() {
    if (!pendingVpnCheckForm) {
      closeVpnModal();
      return;
    }

    var confirmedForm = pendingVpnCheckForm;
    $(confirmedForm).data('vpnConfirmed', true);
    closeVpnModal(false);
    confirmedForm.requestSubmit();
  });

  if (!navigator.cookieEnabled) {
    $('.infection-check__content__attention span').html('Cookieを有効にしてください<br>無効な状態では検査結果の閲覧ができません')
    $('input[name="registration[mail]"]').prop('disabled', true)
    $('select[name="registration[network]"]').prop('disabled', true)
    $('select[name="registration[reason]"]').prop('disabled', true)
    $('.infection-check__content__form__submit__agreement').html('Cookieを有効にする方法は<a href="#qa18">こちら</a>')
    $('.infection-check__content__form__submit').addClass('infection-check__content__form__submit--disabled')
    $('.infection-check__content__form__submit input').prop('disabled', true)
    $('.infection-check__content__form__submit input').val('Cookieを有効にしてください')
  }
})
